module.exports = __webpack_public_path__ + "static/media/high-gpa.db143a15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/high-gpa.jpg
// module id = 632
// module chunks = 11